import React from "react";
import "./LoadingSpinner.css";
import ImageWithBasePath from "core/img/imagewithbasebath";

const LoadingSpinner = () => {
  return (
<div className="overlay">
  <div className="spinner-ring">
    <ImageWithBasePath src="assets/img/logo-small.png" className="logo-center" />
    <div className="ring"></div>
  </div>
</div>

  );
};

export default LoadingSpinner;
